import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { SkipDialogGraphic } from '@ui/kit/icons';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { useCurrentTaskEntryId } from '../hook.entry.js';
import { useFinishEntryMutation } from '../mutations/finish.js';
import { useSkipCurrentTaskMutation } from '../mutations/task.skip.js';
import { finishEntryModalConfig } from './finish.js';
import { body, heading } from './shared.modal.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function useSkipCurrentTaskAction() {
  const notifier = useNotifier();
  const component = useOpgavekompleksetComponent();
  const activeTaskId = useCurrentTaskEntryId();
  const skipMutation = useSkipCurrentTaskMutation();
  const finishMutation = useFinishEntryMutation();
  return useCallback(async () => {
    const hasNextTask = component.data.tasks.findIndex(it => it.id === activeTaskId) !== component.data.tasks.length - 1;
    if (hasNextTask) {
      if ((await notifier.confirm(skipModalConfig)) === "ok") {
        skipMutation();
      }
    } else {
      if ((await notifier.confirm(finishEntryModalConfig)) === "ok") {
        finishMutation({
          markCurrentTaskAsSkipped: true
        });
      }
    }
  }, [activeTaskId, component.data.tasks, finishMutation, notifier, skipMutation]);
}
const skipModalConfig = {
  heading: /*#__PURE__*/jsxs("span", {
    className: heading,
    children: [/*#__PURE__*/jsx(SkipDialogGraphic, {
      role: "presentation"
    }), /*#__PURE__*/jsx("span", {
      children: "Vil du springe denne opgave over?"
    })]
  }),
  body: /*#__PURE__*/jsx("span", {
    className: body,
    children: "Du kan ikke l\xF8se den senere"
  }),
  labels: {
    ok: "Ja, spring over",
    cancel: "Nej, tilbage til opgaven"
  }
};

export { useSkipCurrentTaskAction };
//# sourceMappingURL=task.skip.js.map
